import './atmosphere.css'

/*
 * The Atmospheric Arc + ambient glow (Design System v1.0 — layer 1).
 * The arc is a chained multi-segment quadratic path through the REAL measured
 * brightest-pixel coordinates (fractions of canvas w/h), not a guessed bezier:
 *   (35,43.1) (45,34.1) (55,31.7) (65,29.8) (75,28.5) (85,27.8)
 * Rendered in a 100x100 viewBox (preserveAspectRatio none) so the fractions map
 * directly. Soft Gaussian bleed, never a hard-edged line.
 */
const PTS = [
  [35, 43.1], [45, 34.1], [55, 31.7], [65, 29.8], [75, 28.5], [85, 27.8],
]

function arcPath(pts) {
  // Smooth chained quadratics: control point = each measured point, endpoint =
  // midpoint to the next. Start a little before the first measured point.
  let d = `M ${pts[0][0] - 8} ${pts[0][1] + 6}`
  for (let i = 0; i < pts.length - 1; i++) {
    const [cx, cy] = pts[i]
    const mx = (pts[i][0] + pts[i + 1][0]) / 2
    const my = (pts[i][1] + pts[i + 1][1]) / 2
    d += ` Q ${cx} ${cy} ${mx} ${my}`
  }
  const last = pts[pts.length - 1]
  d += ` T ${last[0] + 12} ${last[1] - 0.4}`
  return d
}

export default function Atmosphere() {
  return (
    <div className="atmosphere" aria-hidden="true">
      <svg
        className="atmosphere__arc"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="arcGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#5FA8FF" stopOpacity="0" />
            <stop offset="45%" stopColor="#8FC8FF" stopOpacity="0.55" />
            <stop offset="70%" stopColor="#DCEBFF" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#8FC8FF" stopOpacity="0.15" />
          </linearGradient>
          <filter id="arcBlur" x="-30%" y="-60%" width="160%" height="260%">
            <feGaussianBlur stdDeviation="0.9" />
          </filter>
        </defs>
        <path d={arcPath(PTS)} stroke="url(#arcGrad)" strokeWidth="0.7"
              fill="none" filter="url(#arcBlur)" strokeLinecap="round" />
        <path d={arcPath(PTS)} stroke="url(#arcGrad)" strokeWidth="0.28"
              fill="none" strokeLinecap="round" />
      </svg>
    </div>
  )
}
